// Mutations
export const SET_ADS_BANNER = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.adsBanner.data = payload
    state.adsBanner.lastUpdate = new Date()
  }
}
export const ADD_ADS_BANNER = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.adsBanner.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.adsBanner.data.push(data)
      }
    })
  }
}
export const SET_ADS_BANNER_LOADING = (state, payload) => {
  state.adsBanner.loading = payload
}

export const SET_AAWZ_FEED = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.aawzFeed.data = payload
    state.aawzFeed.lastUpdate = new Date()
  }
}
export const ADD_AAWZ_FEED = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.aawzFeed.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.aawzFeed.data.push(data)
      }
    })
  }
}
export const SET_AAWZ_FEED_LOADING = (state, payload) => {
  state.aawzFeed.loading = payload
}

export const SET_EXTERNAL_LINKS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.externalLinks.data = payload
    state.externalLinks.lastUpdate = new Date()
  }
}
export const ADD_EXTERNAL_LINKS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.externalLinks.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.externalLinks.data.push(data)
      }
    })
  }
}
export const SET_EXTERNAL_LINKS_LOADING = (state, payload) => {
  state.externalLinks.loading = payload
}

